import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useButton } from '~Hooks';
import { Button } from '~Styles';

const StyledButton = styled(Button)<{ isSelected: boolean }>`
  background: ${(props) =>
    props.isSelected ? 'var(--colorGradientGreen)' : 'var(--colorBlueGray1000)'};
  color: var(--colorWhite);
  white-space: nowrap;
  width: 100%;
  &:active {
    background-color: var(--colorBlueGray900);
  }
`;

interface Props {
  label: string;
  isSelected: boolean;
  onSelect: () => void;
}

/** Extracted to its own component to support useButton */
const PauseOptionButton: FC<Props> = ({ label, isSelected, onSelect }) => {
  const button = useButton({
    onClick: onSelect,
  });

  return (
    <StyledButton {...button} size="large" isSelected={isSelected}>
      {label}
    </StyledButton>
  );
};

export default PauseOptionButton;
